<section>
    <div class="progress">
        <div class="progress-item" *ngFor="let step of purchaseProcessService.experimentalSteps">
			<div class="progress-item-box" *ngIf="isInactiveCurrentStep(step)" [ngClass]="currentStepClass(step)">
				<div class="step">{{step.step}}</div>
				<div class="label">{{step.label}}</div>
				<div class="mobile-label">{{ step.mobileLabel}}</div>
			</div>

			<div class="progress-item-box active" *ngIf="isActiveStep(step)">
				<a [routerLink]="step.path" [queryParams]="step.queryParams" [ngClass]="currentStepClass(step)">
					<div class="step"><img src="../../../assets/img/features/check-icon.svg" alt=""></div>
					<div class="label">{{step.label}}</div>
				</a>
			</div>
        </div>
    </div>
</section>
